@if (matrixQuestion.rows[0].type === "SINGLE_CHOICE") {
  @if (allRowsHaveRequiredError) {
    <app-validator
      [question]="matrixQuestion"
      [validator]="ValidatorType.RequiredSelect"
    />
  }
  @if (!isMobileView && !isSliderPresentation) {
    <div class="w-full max-w-full matrix-wrapper">
      <!-- Sticky header (clone) -->
      <div class="matrix-sticky-header" #stickyHeader aria-hidden="true">
        <div class="matrix-sticky-corner"></div>
        <div class="matrix-sticky-clip">
          <div class="matrix-sticky-inner" #stickyInner>
            <table class="table sticky-header-table">
              <thead>
                <tr class="align-top">
                  <th
                    class="sticky left-0 min-w-64"
                    scope="col"
                    aria-hidden="true"
                  ></th>
                  @for (
                    alternative of matrixQuestion.rows[0].alternatives;
                    track $index
                  ) {
                    <th
                      class="px-1 text-wrap"
                      scope="col"
                      [style.width]="
                        getColumnWidth(
                          matrixQuestion.rows[0].alternatives.length,
                          matrixQuestion.rows[0].alternatives,
                          matrixQuestion.rows[0].id
                        )
                      "
                      [style.min-width]="
                        getColumnMinWidth(
                          alternative.title,
                          matrixQuestion.rows[0].id
                        )
                      "
                    >
                      <div class="inline-block">
                        @if (alternative.image) {
                          <img
                            [src]="alternative.image.url"
                            [alt]="
                              alternative.image.alternateText || alternative.title
                            "
                            [style.width.px]="alternative.image.width"
                            [style.height.px]="alternative.image.height"
                            [style.object-fit]="'fill'"
                            [style.display]="'block'"
                          />
                        }
                        @if (!alternative.image?.hideTitle) {
                          <span [innerHTML]="alternative.title | safeHtml"></span>
                        }
                      </div>
                    </th>
                  }
                </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>

      <!-- Main table container -->
      <div class="table-container" #tableContainer (scroll)="onTableScroll()">
        <table
          class="table mt-8 mb-4"
          [style.--header-first-row-height]="headerFirstRowHeight + 'px'"
        >
          <thead>
            <tr class="align-top">
              <th
                class="sticky left-0 min-w-64"
                scope="col"
                [id]="'corner-' + matrixQuestion.id"
                aria-hidden="true"
              ></th>
              @for (
                alternative of matrixQuestion.rows[0].alternatives;
                track $index
              ) {
                <th
                  class="px-1 text-wrap"
                  scope="col"
                  [style.width]="
                    getColumnWidth(
                      matrixQuestion.rows[0].alternatives.length,
                      matrixQuestion.rows[0].alternatives,
                      matrixQuestion.rows[0].id
                    )
                  "
                  [style.min-width]="
                    getColumnMinWidth(
                      alternative.title,
                      matrixQuestion.rows[0].id
                    )
                  "
                  [id]="(alternative.title | toValidId) + '-' + matrixQuestion.id"
                >
                  <div class="inline-block">
                    @if (alternative.image) {
                      <img
                        [src]="alternative.image.url"
                        [alt]="
                          alternative.image.alternateText || alternative.title
                        "
                        [style.width.px]="alternative.image.width"
                        [style.height.px]="alternative.image.height"
                        [style.object-fit]="'fill'"
                        [style.display]="'block'"
                      />
                    }
                    @if (!alternative.image?.hideTitle) {
                      <span [innerHTML]="alternative.title | safeHtml"></span>
                    }
                  </div>
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (question of matrixQuestion.rows; track $index) {
              @if (question.type === "SINGLE_CHOICE") {
                <app-matrix-single-select-row
                  class="contents"
                  [question]="question"
                  [control]="form?.get(question.id)!"
                  [otherControl]="form?.get(question.id + '-OTHER')"
                  [matrixQuestionId]="matrixQuestion.id"
                  [hideError]="allRowsHaveRequiredError"
                >
                </app-matrix-single-select-row>
              }
            }
          </tbody>
        </table>
      </div>

      <!-- Custom scrollbar -->
      @if (hasHorizontalOverflow) {
        <div
          class="custom-scrollbar-track"
          #scrollbarTrack
          [style.margin-left.px]="firstColumnWidth"
          (mousedown)="onScrollbarTrackClick($event)"
        >
          <div
            class="custom-scrollbar-thumb"
            [style.width.px]="scrollbarThumbWidth"
            [style.transform]="'translateX(' + scrollbarThumbPosition + 'px)'"
            (mousedown)="onScrollbarThumbMouseDown($event)"
          ></div>
        </div>
      }
    </div>
  }

  <!-- SLIDER presentation - simple table without sticky wrapper -->
  @if (!isMobileView && isSliderPresentation) {
    <table class="table mt-8 mb-4">
      <tbody>
        @for (question of matrixQuestion.rows; track $index) {
          @if (question.type === "SINGLE_CHOICE") {
            <app-matrix-single-select-row
              class="contents"
              [question]="question"
              [control]="form?.get(question.id)!"
              [otherControl]="form?.get(question.id + '-OTHER')"
              [matrixQuestionId]="matrixQuestion.id"
              [hideError]="allRowsHaveRequiredError"
            >
            </app-matrix-single-select-row>
          }
        }
      </tbody>
    </table>
  }

  @if (isMobileView) {
    <div class="block">
      @for (question of matrixQuestion.rows; track $index) {
        @if (question.type === "SINGLE_CHOICE") {
          <div class="mb-4">
            <app-matrix-single-select-row
              [question]="question"
              [control]="form?.get(question.id)!"
              [otherControl]="form?.get(question.id + '-OTHER')"
              [hideError]="allRowsHaveRequiredError"
            ></app-matrix-single-select-row>
          </div>
        }
      }
    </div>
  }
}
